import React from 'react';
import NoAccess from '../../Views/Auth0/NoAccess';

const check = (rule, userPermissions) => {
    return (Array.isArray(userPermissions) && (userPermissions.includes(rule) || userPermissions.includes(rule.replace('/view', ''))));
  };
  
  const Can = ({ yes = () => null, no = (props) => <NoAccess {...props} />, ...rest }) =>
    check(rest.rule, rest.permissions)
      ? yes({ yes, no, ...rest })
      : no({ yes, no, ...rest });
  
  export default Can;